/* @flow */
import React from 'react'
import Toggle from 'react-toggle'

import './OpinaryToggle.css'

export default function OpinaryToggle({
  toggled,
  label,
  onChange,
  className = '',
}: {
  toggled: boolean,
  label: string,
  onChange: (toggled: boolean) => void,
  className?: string,
}) {
  return (
    <label className={`flex justify-between ${className}`}>
      <span className="gray mr3" style={{ verticalAlign: 'super' }}>
        {label}
      </span>
      <Toggle
        className="op-toggle"
        icons={{
          checked: <span>Yes</span>,
          unchecked: <span>No</span>,
        }}
        checked={toggled ? true : false}
        onChange={e => onChange(e.target.checked)}
      />
    </label>
  )
}



// WEBPACK FOOTER //
// ./src/components/Controls/OpinaryToggle.js